import { FilledImageFieldImage, Slice, SliceZone } from '@prismicio/client'
import { Grid, Typography } from '@dtx-company/design-system/src'

import {
  BannerTextSlice,
  LogoSlice,
  UpsellModalBannerSlice
} from '@app/upsell-modals/src/PrismicUpsellModalContent/UpsellModalPrismicDocument'
import { SliceZone as PrismicSliceZone, SliceComponentProps } from '@prismicio/react'
import Image from 'next/image'
import React from 'react'

type FilledTextSlice = Slice<'text', { text: string }>
type FilledLogoSlice = Slice<'logo', { image: FilledImageFieldImage }>

const _UpsellModalBannerTextSlice = ({
  slice
}: SliceComponentProps<FilledTextSlice>): JSX.Element => {
  const {
    id,
    primary: { text }
  } = slice
  return (
    <Grid key={id} xs={12}>
      <Typography component="span" variant="subtitleSmall">
        {text}
      </Typography>
    </Grid>
  )
}

const _UpsellModalBannerLogoSlice = ({
  slice
}: SliceComponentProps<FilledLogoSlice>): JSX.Element => {
  const {
    id,
    primary: { image }
  } = slice
  return (
    <Grid key={slice.id} xs={3}>
      <Image
        key={id}
        src={image.url}
        alt={image.alt || ''}
        height={image.dimensions.height}
        width={image.dimensions.width}
      />
    </Grid>
  )
}

const bannerSliceComponents: Record<
  UpsellModalBannerSlice['slice_type'],
  React.ComponentType<any>
> = {
  logo: _UpsellModalBannerLogoSlice,
  text: _UpsellModalBannerTextSlice
}

export function PrismicUpsellModalContentAidaBanner(props: {
  sliceZone?: SliceZone<BannerTextSlice | LogoSlice>
}): JSX.Element | null {
  const { sliceZone } = props
  return (
    <Grid container sx={{ maxWidth: 380, margin: 'auto', justifyContent: 'center' }} spacing={2}>
      <PrismicSliceZone slices={sliceZone} components={bannerSliceComponents} />
    </Grid>
  )
}
